interface AboutSectionProps {
  summary?: string
}

export function AboutSection({ summary }: AboutSectionProps) {
  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">About</h2>
      <p className="whitespace-pre-wrap">
        {summary || 'No description available.'}
      </p>
    </div>
  )
}
